module.exports = __webpack_public_path__ + "static/img/img8.2d5a856.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/img8.jpg
// module id = Lu8C
// module chunks = 0